var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 28.0002C13.332 25.791 15.2681 24.0002 17.6564 24.0002H39.9987V28.0002H13.332Z",
    fill: "#0ED6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 50.6668H37.332V54.6668H17.332V50.6668Z",
    fill: "#117BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.332 50.6668H45.9987V54.6668H37.332V50.6668Z",
    fill: "#117BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6654 24.0002C48.8745 24.0002 50.6654 25.9738 50.6654 28.4083V48.0002H46.6654V24.0002Z",
    fill: "#13E0F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 54.6668C15.1229 54.6668 13.332 52.6932 13.332 50.2587L13.332 42.6668H17.332V54.6668Z",
    fill: "#01AAE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9987 24.0002H46.6654V28.0002H39.9987V24.0002Z",
    fill: "#0CC4E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 28.0002H17.332V42.6668H13.332L13.332 28.0002Z",
    fill: "#0ED6E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6654 18.6668H22.6654V24.0002H18.6654V18.6668Z",
    fill: "#117BC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9987 9.3335C30.773 9.3335 29.5594 9.57491 28.427 10.044C27.2946 10.513 26.2657 11.2005 25.399 12.0672C24.5324 12.9338 23.8449 13.9627 23.3758 15.0951C22.9068 16.2275 22.6654 17.4412 22.6654 18.6668H18.6654C18.6654 16.9159 19.0102 15.1821 19.6803 13.5644C20.3504 11.9467 21.3325 10.4769 22.5706 9.23874C23.8087 8.00063 25.2786 7.0185 26.8963 6.34844C28.5139 5.67837 30.2477 5.3335 31.9987 5.3335C33.7497 5.3335 35.4835 5.67837 37.1011 6.34844C38.7188 7.0185 40.1887 8.00062 41.4268 9.23874C42.6649 10.4769 43.647 11.9467 44.3171 13.5644L40.6216 15.0951C40.1525 13.9627 39.465 12.9338 38.5984 12.0672C37.7317 11.2005 36.7028 10.513 35.5704 10.044C34.438 9.57491 33.2244 9.3335 31.9987 9.3335Z",
    fill: "#0ED6E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3171 13.5644C44.9872 15.1821 45.332 16.9155 45.332 18.6664V24.0002H41.332L41.332 18.6664C41.332 17.4407 41.0906 16.2275 40.6216 15.0951L44.3171 13.5644Z",
    fill: "#0092C0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.332 37.3335C29.332 35.8607 30.5259 34.6668 31.9987 34.6668C33.4715 34.6668 34.6654 35.8607 34.6654 37.3335V45.3335H29.332V37.3335Z",
    fill: "#117BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.c4d130447de723cb02b52fde2f23cb87.svg";
export { ForwardRef as ReactComponent };